import packageJson from '../../package.json'

/**
 * Identificação do build em execução.
 *
 * `buildId` é gerado no `vue.config.js` (um por build) e embutido pelo DefinePlugin;
 * o mesmo valor vai para o `/version.json` publicado junto. Fica vazio quando o build
 * não o define (ex.: testes) — aí a checagem de versão nova fica desligada.
 */
export const buildInfo = {
  buildId: process.env.VUE_APP_BUILD_ID ?? '',
  version: packageJson.version
} as const
